import { NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Columns, Row } from '@app/components/simple-table/simple-table.component';
import { EptSummary } from '@app/models/payroll/ept-summary.model';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { PlatformModule } from '@app/platform.module';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

/**
 * This is shown to the user after they finish running payroll.
 * It displays the EPT amounts owing and provides links to the government payment portals.
 */
@Component({
    standalone: true,
    selector: 'app-other-remittances-pay',
    templateUrl: './other-remittances-pay.template.html',
    imports: [PlatformModule, TranslateModule, NgIf],
})
export class OtherRemittancesPayComponent implements OnInit {
    @Input({ required: true }) eptSummaries!: EptSummary[];
    @Input() useBanner = false;

    columns: Columns[] = [
        { columnName: 'payroll.run.otherRemittancesPay.name', columnSpan: 'columns-3' },
        {
            columnName: 'payroll.run.otherRemittancesPay.filingDate',
            columnSpan: 'columns-2',
            columnType: CellDisplay.date,
        },
        {
            columnName: 'payroll.run.otherRemittancesPay.paymentDate',
            columnSpan: 'columns-2',
            columnType: CellDisplay.date,
        },
        {
            columnName: 'payroll.run.otherRemittancesPay.amountOwing',
            columnSpan: 'columns-2',
            columnType: CellDisplay.dollar,
        },
    ];

    rows: Row[] = [];

    constructor(private translateService: TranslateService) {}

    ngOnInit(): void {
        this.rows = this.eptSummaries.map((eptSummary) => ({
            cells: [
                `${this.translateService.instant('payroll.records.ept.' + eptSummary.jurisdictionArea)} (${eptSummary.jurisdictionArea} ${eptSummary.details.displayName})`,
                eptSummary.upcomingFilingDate.toString(),
                eptSummary.upcomingPaymentDate.toString(),
                eptSummary.periodBalanceDue,
            ],
        }));
    }

    /**
     * Open the government payment portal in a new tab
     */
    goToPay(index: number): void {
        // find url and open in new tab
        window.open(this.eptSummaries[index].details.paymentUrl, '_blank');
    }
}
